import { GetMerchantStatusBackgroundColorPipe } from './components/home/partners/mart-onboarding/get-merchant-background-color.pipe';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';

import player from 'lottie-web';
import { LottieModule } from 'ngx-lottie';

import { ImageCropperModule } from 'ngx-image-cropper';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { CurrencyOrEmptyPipe } from './pipes';

// Material
import { AppMaterialModule } from './app-material.module';

import {
    ApiHttp, ErrorProvider,
    HttpProvider
} from 'app/providers';

import {
    AdminXpressConnexService,
    AppDataService,
    ChatService,
    QuestService,
    IncentiveQuestService,
    SignalrService,
    ConfigService,
    DashboardService,
    DeliveryOrderService,
    FoodService,
    GeoZoneService,
    GoogleFleetService,
    GooglePlacesService,
    LokalOrderService,
    MenuService,
    MerchantService,
    TourOperatorService,
    MerchantUserService,
    NationalityService,
    PartnerDashboardService,
    PartnerOrderService,
    PartnerProfileService,
    PartnerFinanceService,
    ProductService,
    PromosService,
    PromotionMaterialsService,
    PromoSponsorService,
    PromoBudgetService,
    ReportXpressService,
    RiderScheduleTrainingCenterService,
    RiderService,
    SplashScreenStateService,
    StoreService,
    BoatInquiryService,
    XpressCenterService,
    XpressPaymentTransactionService,
    XpressUserService,
    ZohoSignService,
    XpressDisciplinaryService,
    XpressCodeConductService,
    BroadcastMessageService,
    TODAService,
    VehicleBrandService,
    WeblogService,
    UserFeedbackService
} from 'app/services';

import { OperatorDashboardService } from 'app/services/operator/operator-dashboard.service';

import { FullCalendarModule } from '@fullcalendar/angular';
import {
    ActiveOrderDetailComponent, ActiveOrdersComponent,
    ActiveOrdersFilterComponent
} from 'app/active-orders';
import { ChatComponent } from 'app/chat';
import { CourierComponent } from 'app/courier';
import { DeliveryOrderComponent } from 'app/delivery-order';
import {
    EditFoodCategoryComponent,
    EditFoodModifierComponent,
    EditFoodModifierGroupComponent,
    EditFoodProductComponent,
    EditRestaurantComponent,
    FoodCategoriesComponent,
    FoodModifierGroupsComponent,
    FoodModifiersComponent,
    FoodProductsComponent,
    FoodRestaurantsComponent,
    FoodRootComponent
} from 'app/food';
import { HireRootComponent } from 'app/hire';
import {
    ApproveDocsMartPartnerComponent,
    CreateMartPartnerComponent,
    CustomerInfoComponent,
    CustomersComponent,
    DetailMartPartnerComponent,
    DisciplinaryFilterComponent,
    DisciplinaryInfoComponent,
    DriverCenterCreateComponent,
    DriverCenterInfoComponent,
    DriverCentersFilterComponent,
    DriverDetailComponent,
    DriverOrderDetailComponent,
    DriversComponent,
    DriversFilterComponent,
    DriverTransactionDetailComponent,
    EditVehicleModalComponent,
    HomeAccountingComponent,
    HomeCalendarComponent,
    HomeComponent,
    HomeDisciplinaryComponent,
    HomeDriverCentersComponent,
    HomeDriverTrainingComponent,
    HomeRootComponent,
    HomeTransactionDetailsComponent,
    HomeTransactionsComponent,
    MartOnboardingComponent,
    OnboardingVehiclesComponent,
    ReviewPartnerInfoComponent,
    SidebarExistingRiderVehicleDetailComponent,
    SuspendPartnerComponent,
    SuspendUserComponent,
    UserFilterComponent,
    AddOrUpdateDisciplinaryComponent,
    DisciplinaryDetailComponent,
    DisciplinaryInvestigationComponent,
    AddHearingOrReasonComponent,
    CustomerTransactionDetailComponent,
    DriverPayoutInvoiceComponent,
    DriversDraftComponent,
    CustomersSuspendAndBlacklistComponent,
    DriverAddComponent,
    BannedUserComponent,
    VehicleOwnerDetailComponent,
    CustomerOrderDetailComponent,
    DriversCompaignComponent,
    DriversCompaignExportSidebarComponent,
    DriversCompaignXpress50Component,
    DriverCampaignXpress50RewardComponent,
    DriverUploadDocDialogComponent,
    CustomerManageDiscountDialogComponent
} from 'app/home';
import {
    ConfigComponent,
    MenuComponent,
    MenuitemComponent,
    TopbarComponent,
    XpressTopbarComponent,
} from 'app/layout';
import { MenuitemPartnersComponent } from '../app/components/layout/menuitem-partners/menuitem-partners.component';
import {
    LiveMapAssignRiderComponent
} from 'app/live-map/live-map-active-orders/live-map-assign-rider/live-map-assign-rider.component';
import {
    MartDetailMerchantComponent,
    MartMerchantsComponent,
    MartOrderDetailsChatTabComponent,
    MartOrderDetailsComponent,
    MartOrderDetailsInfoTabComponent,
    MartOrderDetailsPaymentTabComponent,
    MartOrderDetailsProductsTabComponent,
    MartOrderDetailsTimelineTabComponent,
    MartRootComponent
} from 'app/mart';
import {
    CreateMerchantEmployeeComponent,
    MerchantActivationComponent,
    MerchantApprovedRejectProductComponent,
    MerchantCompanyConfirmComponent,
    MerchantConfirmOnboardingComponent,
    MerchantCreatePaymentComponent,
    MerchantCreateProductComponent,
    MerchantCreateStoreComponent,
    MerchantDetailPaymentComponent,
    MerchantDetailProductComponent,
    MerchantEditProductComponent,
    MerchantEmployeeDetailComponent,
    MerchantEmployeesComponent,
    MerchantInformationConfirmComponent,
    MerchantProductsComponent,
    MerchantRejectProductComponent,
    MerchantSignContractComponent,
    MerchantStoreDetailComponent,
    MerchantStoreOnboardingComponent,
    MerchantUploadDocumentComponent,
    MerchantPaymentComponent,
    MerchantPaymentViewComponent,
    MerchantPaymentMethodModalComponent,
    MerchantPaymentMethodSidebarComponent,
    MerchantPaymentDetailsComponent,

} from 'app/merchant';
import {
    LegalDocumentsUpdateComponent,
    LibraryStoreImagesComponent,
    PartnerAppConfigCategoriesComponent,
    PartnerAppConfigRecommendedProductsComponent,
    PartnerAppconfigRootComponent,
    PartnerAppConfigStoreBrandingComponent,
    PartnerBusinessInfoUpdateComponent,
    PartnerDashboardComponent,
    PartnerDashboardRootComponent,
    PartnerDashboardSwitchComponent,
    PartnerDeleteEmployeeComponent,
    PartnerEmployeeDetailsComponent,
    PartnerEmployeeResetPasswordComponent,
    PartnerEmployeesComponent,
    PartnerEmployeesRootComponent,
    PartnerFinanceRootComponent,
    PartnerFinanceTransactionDetailComponent,
    PartnerFinanceTransactionFilterComponent,
    PartnerFinanceTransactionsComponent,
    PartnerInsightsRootComponent,
    PartnerInventoryRootComponent,
    PartnerMarketingAddEditPromotionComponent,
    PartnerMarketingFilterPromotionComponent,
    PartnerMarketingPromotionsComponent,
    PartnerMarketingRootComponent,
    PartnerMartLocationsActiveServicesComponent,
    PartnerMartLocationsComponent,
    PartnerMartLocationsCreateGroupComponent,
    PartnerMartLocationsDeliveryDetailComponent,
    PartnerMartLocationsEditGroupComponent,
    PartnerMartLocationsEmployeeComponent,
    PartnerMartLocationsGroupDetailsComponent,
    PartnerMartLocationsGroupHoursComponent,
    PartnerMartLocationsGroupInventoryComponent,
    PartnerMartLocationsGroupsComponent,
    PartnerMartLocationsGroupStoresComponent,
    PartnerMartLocationsHandoffComponent,
    PartnerMartLocationsHeaderComponent,
    PartnerMartLocationsHoursComponent,
    PartnerMartLocationsInventoryComponent,
    PartnerMartLocationsInventoryGridComponent,
    PartnerMartLocationsLegalDocumentsComponent,
    PartnerMartLocationsRootComponent,
    PartnerMartLocationsSidebarHoursComponent,
    PartnerMartLocationsStoreCreateComponent,
    PartnerMartLocationsStoreDetailsComponent,
    PartnerMartLocationsStoreHoursComponent,
    PartnerOrdersComponent,
    PartnerOrdersFeedbackComponent,
    PartnerOrdersFilterComponent,
    PartnerOrdersRootComponent,
    PartnerPayoutAccountDetailsComponent,
    PartnerProfileComponent,
    PartnerProfileEmailTabComponent,
    PartnerProfileInfoTabComponent,
    PartnerProfileSecurityTabComponent,
    PartnerProvideAccessComponent,
    PartnerSettingsAuthorizedRepresentativeComponent,
    PartnerSettingsBusinessInfoComponent,
    PartnerSettingsLegalDocumentsComponent,
    PartnerSettingsLegalDocumentStatusComponent,
    PartnerSettingsPartnershipTermsComponent,
    PartnerSettingsPayoutAccountComponent,
    PartnerSettingsRootComponent,
    PartnerSettingsUpdateLegalDocumentsComponent,
    PartnerSuspendEmployeeComponent,
    UploadStoreImageComponent,
    PartnerRootComponent,
    PartnerInventoryAllProductsComponent
} from 'app/partner';
import { PartnerFinanceReportsComponent }
from 'app/components/partner/partner-finance/partner-finance-reports/partner-finance-reports.component';
import { PartnerFinanceSettlementReportsComponent }
from 'app/components/partner/partner-finance/partner-finance-settlement-reports/partner-finance-settlement-reports.component';
import {
    PartnerInsightsReportsComponent,
    MostPopularProductsComponent,
    SlowestMovingProductsComponent,
    MostPopularCombinationsComponent,
    MostSearchedProductsComponent
} from 'app/components/partner';
import {BookingDetailComponent} from 'app/active-orders/booking-detail/booking-detail.component';
import {BookingReceiptComponent} from 'app/active-orders/booking-detail/booking-receipt/booking-receipt.component';
import { RideComponent } from 'app/ride';
import {
    ServiceTypePromotionAddUpdateComponent,
    ServiceTypePromotionFilterComponent, ServiceTypePromotionsComponent, ServiceTypePromotionsDetailComponent, ServiceTypeReportsComponent
} from 'app/service-type';
import { ServiceTypeRootComponent } from 'app/service-type-root';
import {
    ServicesAndFaresComponent,
    ServicesAndFaresEditComponent
} from 'app/services-and-fares';
import { SplashComponent } from 'app/splash';
import {
    SupportRootComponent,
    SupportDriversComponent,
    SupportCustomersComponent
} from 'app/support';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ComplaintsRootComponent } from 'app/complaints';
import {
    FinanceDashboardComponent, FinancePayoutComponent, FinancePayoutDetailsComponent, FinancePayoutSettingsComponent,
    AccountingDashboardComponent, FinancePayoutOnlineTransferComponent, FinanceXenditComponent, FinanceCommerceComponent
} from 'app/finance';
import {
    HomeTransactionsFilterComponent
} from 'app/home/home-transactions/home-transactions-filter/home-transactions-filter.component';
import {
    OpsTowerRootComponent,
    OpsTowerTODAsComponent,
    ReportDailyStatisticsComponent,
    ReportDriverPerformanceComponent,
    ReportQuestsComponent
} from 'app/ops-tower';
import {
    BackOfficeRootComponent, CampaignUsersRootComponent, CampaignUsersTransactionsComponent, CampaignUsersUsersComponent,
    OperatorVehiclesComponent, AddOperatorVehicleComponent, OperatorsComponent, ExportOperatorsComponent, OperatorVehicleDetailComponent,
    AddDriversToVehicleDialogComponent, EditBoundaryFeeDialogComponent, OperatorVehicleInsightsComponent, TaxiVehiclesComponent, CreateTaxiVehicleComponent,
    TaxiVehicleDetailComponent, ConnexRouteConfigurationComponent, ConnexRouteEditDrawerComponent,
    ConnexAssigningDriversTabComponent, ConnexManageDriversDrawerComponent
} from 'app/back-office';
import { ConnexBookingsComponent } from 'app/components/ops-tower/connex-bookings/connex-bookings.component';
import { ConnexWalkInBookingDrawerComponent } from 'app/components/ops-tower/connex-bookings/connex-walk-in-booking-drawer/connex-walk-in-booking-drawer.component';
import {
	MarketingRootComponent, CustomerQuestComponent, IncentiveQuestComponent, IncentiveEditComponent,
	RefferalReportComponent, PromoBudgetComponent, PromoSponsorComponent, PromotionMaterialsComponent
} from 'app/marketing';
import {
    FinancePayoutUploadComponent
} from 'app/finance/finance-payout/finance-payout-upload/finance-payout-upload.component';
import {
    FinancePayoutCebuanaComponent
} from 'app/finance/finance-payout/finance-payout-cebuana/finance-payout-cebuana.component';
import {PayoutTransactionService} from 'app/services/payout-transaction.service';
import {CebuanaPayoutTransactionService} from 'app/services/cebuana-payout-transaction.service';
import { ClipboardModule } from '@angular/cdk/clipboard';
import {UserManagementService} from 'app/services/user-management.service';
import {UserTableSettingsService} from 'app/services/user-table-settings.service';
import {XpressCalendarComponent} from 'app/components/xpress-calendar/xpress-calendar.component';
import {CampaignUsersService} from 'app/services/campaign-users.service';
import { PaymentProcessingService } from 'app/services/payment-processing.service';
import { ArchivingImagesService } from 'app/services/archiving-images.service';
import { OperatorService } from 'app/services/operator.service';
import { MLService } from 'app/services/ml.service';
import { AuthService } from 'app/services/auth.service';
import { JL } from 'jsnlog';
import { NgForOf, NgIf, NgSwitchCase } from '@angular/common';
import {RegionMapEditorService} from 'app/services/map/region-map-editor.service';

import { CreateAmenityComponent } from 'app/settings';

import {
    DndDirective,
    OperatorLoginComponent,
    OperatorSignupComponent
} from 'app/operator';
import {OperatorTransactionsComponent} from 'app/operator/operator-transactions/operator-transactions.component';
import { ProfileDetailComponent } from './components/layout/xpress-topbar/profile/profile-detail/profile-detail.component';
import { GetChartDataPipe } from './components/operator/dashboard/get-chart-data.pipe';
import { EditHubComponent } from './features/settings/components/hub/edit-hub/edit-hub.component';
import { ViewHubComponent } from './features/settings/components/hub/view-hub/view-hub.component';
import { GetIconPercentPipe } from './components/operator/dashboard/get-icon-percent.pipe';
import { OneTimePasswordComponent } from './components/operator/one-time-password/one-time-password.component';
import { CompanyDetailsComponent } from './components/merchant/merchant-confirm-onboarding/company-details/company-details.component';
import { GetChatMessageTypePipe } from './components/chat/get-chat-message-type.pipe';
import { GetChatMessageTitlePipe } from './components/chat/get-chat-message-title.pipe';
import { GetCurrentChatTypePipe } from './components/chat/get-current-chat-type.pipe';
import { FilesizePipe } from './components/home/drivers/driver-detail/driver-commerce/pipes/filesize.pipe';
import { MessageDialogComponent } from './components/merchant/merchant-confirm-onboarding/message-dialog/message-dialog.component';
import { MerchantCreateEmployeeComponent } from './components/merchant/merchant-store-onboarding/merchant-create-employee/merchant-create-employee.component';
import { MerchantEmployeesSelectionComponent }
    from './components/merchant/merchant-store-onboarding/merchant-employees/merchant-employees-selection/merchant-employees-selection.component';
import { CreateMerchantMultipleEmployeeComponent }
    from './components/merchant/merchant-store-onboarding/merchant-employees/create-merchant-multiple-employee/create-merchant-multiple-employee.component';
// MerchantProduct
import { AddProductDialogComponent } from './components/merchant/merchant-store-onboarding/merchant-products/add-product-dialog/add-product-dialog.component';
import { AddProductSingleDialogComponent
} from './components/merchant/merchant-store-onboarding/merchant-products/add-product-single-dialog/add-product-single-dialog.component';
import { AddProductMultipleDialogComponent }
from './components/merchant/merchant-store-onboarding/merchant-products/add-product-multiple-dialog/add-product-multiple-dialog.component';
import { ProductDetailFormComponent } from
 './components/merchant/merchant-store-onboarding/merchant-products/add-product-single-dialog/product-detail-form/product-detail-form.component';
import { ProductAvailabilityComponent } from
 './components/merchant/merchant-store-onboarding/merchant-products/add-product-single-dialog/product-availability/product-availability.component';
import { ProductPricingFormComponent } from
 './components/merchant/merchant-store-onboarding/merchant-products/add-product-single-dialog/product-pricing-form/product-pricing-form.component';
import { ProductUomFormComponent } from
'./components/merchant/merchant-store-onboarding/merchant-products/add-product-single-dialog/product-uom-form/product-uom-form.component';
import { CurrenyDecimalDirective } from
 './components/merchant/merchant-store-onboarding/merchant-products/add-product-single-dialog/shared/two-digit-decimal-number.directive';
import { RolePermissionsComponent }
    from './components/merchant/merchant-store-onboarding/merchant-employees/create-merchant-single-employee/role-permissions/role-permissions.component';
import { CreateStoreContainerComponent } from './components/merchant/partners-portal/create-store-container/create-store-container.component';
import { StoreOperationHoursDialogComponent }
from
'app/partner/mart/store-creation/store-operation-hours/store-operation-hours.component';
import { PartnerMartCreateStoreComponent }
from 'app/partner/mart/store-creation/partner-mart-create-store-multistep.component';
import {SubscriptionService} from 'app/services/subscription.service';
import {DiscountsReportComponent} from 'app/marketing/discounts-report/discounts-report.component';

//Driver Commerce
import { DriverCommerceComponent } from './components/home/drivers/driver-detail/driver-commerce/driver-commerce.component';
import { ProductTransactionsComponent } from './components/home/drivers/driver-detail/driver-commerce/product-transactions/product-transactions.component';
import { ProductDetailsComponent } from './components/home/drivers/driver-detail/driver-commerce/product-details/product-details.component';
import { XpassBookingDetailComponent } from './components/ops-tower/xpass-detail/xpass-booking-detail';
import { ReassignDriverComponent } from './components/ops-tower/xpass-detail/reassign-driver.component';

import { XpassComponent } from './components/ops-tower/xpass/xpass.component';
import { AddAvailedProductDialogComponent } from
    './components/home/drivers/driver-detail/driver-commerce/add-availed-product-dialog/add-availed-product-dialog.component';
import { AddAvailedProductDetailsComponent } from
    './components/home/drivers/driver-detail/driver-commerce/add-availed-product-dialog/add-availed-product-details/add-availed-product-details.component';
import { AddAvailedProductPaymentTermsComponent } from
    './components/home/drivers/driver-detail/driver-commerce/add-availed-product-dialog/add-availed-product-payment-terms/add-availed-product-payment-terms.component';
import { UploadProductsDialogComponent } from
    './components/home/drivers/driver-detail/driver-commerce/upload-products-dialog/upload-products-dialog.component';
import { AddAvailedProductSummaryComponent } from
    './components/home/drivers/driver-detail/driver-commerce/add-availed-product-dialog/add-availed-product-summary/add-availed-product-summary.component';
//Prime-NG
import { DialogService } from 'primeng/dynamicdialog';
import { AppPrimengModule } from './app-primeng-module';

import { EditAvailedProductDialogComponent } from
'./components/home/drivers/driver-detail/driver-commerce/product-details/edit-availed-product-dialog/edit-availed-product-dialog.component';
import { EditAvailedProductStatusComponent } from
'./components/home/drivers/driver-detail/driver-commerce/product-details/edit-availed-product-dialog/edit-availed-product-status/edit-availed-product-status.component';
import { EditAvailedProductDetailsComponent } from
'./components/home/drivers/driver-detail/driver-commerce/product-details/edit-availed-product-dialog/edit-availed-product-details/edit-availed-product-details.component';
import { EditAvailedProductConfirmComponent } from
'./components/home/drivers/driver-detail/driver-commerce/product-details/edit-availed-product-confirm/edit-availed-product-confirm.component';
import { PartnerMartLocationsDetailsComponent } from
'./components/partner/mart/partner-mart-locations/partner-mart-locations/partner-mart-locations-details/partner-mart-locations-details.component';
import { StoreHoursDetailsComponent } from
'./components/partner/mart/partner-mart-locations/partner-mart-locations/partner-mart-locations-details/store-hours-details/store-hours-details.component';
import { ProductTableViewComponent } from './components/merchant/merchant-store-onboarding/merchant-products/product-view-modes/table-view/table-view.component';
import { ProductGridViewComponent } from './components/merchant/merchant-store-onboarding/merchant-products/product-view-modes/grid-view/grid-view.component';
import { ProductFilterComponent } from './components/merchant/merchant-store-onboarding/merchant-products/product-filter/product-filter.component';
import { MerchantProductsSidebarComponent } from
'./components/merchant/merchant-store-onboarding/merchant-products/merchant-products-sidebar/merchant-products-sidebar.component';
import { ViewProductDialogComponent } from './components/merchant/merchant-store-onboarding/merchant-products/view-product-dialog/view-product-dialog.component';
import { EditProductDialogComponent } from './components/merchant/merchant-store-onboarding/merchant-products/edit-product-dialog/edit-product-dialog.component';
import { PricingTabComponent } from './components/merchant/merchant-store-onboarding/merchant-products/edit-product-dialog/pricing-tab/pricing-tab.component';
import { UomTabComponent } from './components/merchant/merchant-store-onboarding/merchant-products/edit-product-dialog/uom-tab/uom-tab.component';
import { AvailabilityTabComponent } from
'./components/merchant/merchant-store-onboarding/merchant-products/edit-product-dialog/availability-tab/availability-tab.component';
import { ProductDetailViewComponent } from
'./components/merchant/merchant-store-onboarding/merchant-products/view-product-dialog/product-detail-view/product-detail-view.component';
import { ProductPricingViewComponent } from
'./components/merchant/merchant-store-onboarding/merchant-products/view-product-dialog/product-pricing-view/product-pricing-view.component';
import { ProductUomViewComponent } from
'./components/merchant/merchant-store-onboarding/merchant-products/view-product-dialog/product-uom-view/product-uom-view.component';
import { ProductAvailabilityViewComponent } from
'./components/merchant/merchant-store-onboarding/merchant-products/view-product-dialog/product-availability-view/product-availability-view.component';
import { StoreInventoryComponent } from
'./components/partner/mart/partner-mart-locations/partner-mart-locations/partner-mart-locations-details/store-inventory/store-inventory.component';
import { IsMerchantPipe } from './components/layout/xpress-topbar/xpress-topbar.component';
import { AuthInitializerFactory, AuthInitializerService } from './providers';
import { PhoneMaskPipe } from './components/home/drivers/pipes/phone-mask.pipe';
import {
	ReportTaxiPerformanceComponent
} from 'app/ops-tower/reports/report-taxi-driver-performance/report-taxi-driver-performance.component';
import { SharedModule } from '@shared/modules/shared.module';
import { SharedDeliveryOrderService } from '@shared/services/shared-delivery-order.service';
import { CommsModule } from './features/comms/comms.module';
import { TourOperatorsComponent } from 'app/home/partners/tour-operators/tour-operators.component';
import { TourBookingsComponent } from 'app/ops-tower/tour-bookings/tour-bookings.component';
import { ExperienceListingsComponent } from 'app/ops-tower/experience-listings/experience-listings.component';
import { RegistrationV2Component } from 'app/registration/v2';
import { GphToolsComponent } from 'app/features/ops-tower/components/gph-tools/gph-tools.component';
import { OperatorAuthModule } from 'app/features/operator/shared/operator-auth.module';
import { DriversSharedModule } from 'app/components/home/drivers/drivers-shared.module';
import { OperatorFeaturesSharedModule } from 'app/features/operator/shared/operator-features-shared.module';
import { OperatorVehiclesSharedModule } from 'app/features/operator/shared/operator-vehicles-shared.module';
import { CardModule } from 'app/components/card/card.module';
import { DisciplinarySharedModule } from 'app/components/home/home-disciplinary/disciplinary-shared.module';

@NgModule({
    declarations: [
        AppComponent,
        ConfigComponent,
        SplashComponent,
        MenuComponent,
        MenuitemComponent,
        TopbarComponent,
        XpressTopbarComponent,
        MenuitemPartnersComponent,
        HomeRootComponent,
        HomeComponent,
        CustomersComponent,
        UserFilterComponent,
        SuspendUserComponent,
        RideComponent,
        HireRootComponent,
        CourierComponent,
        ServiceTypeRootComponent,
        ActiveOrdersComponent,
        ActiveOrdersFilterComponent,
        ActiveOrderDetailComponent,
        DeliveryOrderComponent,
        ServicesAndFaresComponent,
        ServicesAndFaresEditComponent,
        HomeTransactionsComponent,
        HomeAccountingComponent,
        HomeDriverTrainingComponent,
        HomeDisciplinaryComponent,
        HomeDriverCentersComponent,
        ServiceTypePromotionsComponent,
        ServiceTypeReportsComponent,
        DisciplinaryInfoComponent,
        DisciplinaryFilterComponent,
        DriverCentersFilterComponent,
        DriverCenterInfoComponent,
        DriverCenterCreateComponent,
        ServiceTypePromotionsDetailComponent,
        ServiceTypePromotionAddUpdateComponent,
        ServiceTypePromotionFilterComponent,
        OnboardingVehiclesComponent,
        SidebarExistingRiderVehicleDetailComponent,
        ServiceTypePromotionFilterComponent,
        HomeCalendarComponent,
        MartOnboardingComponent,
        TourOperatorsComponent,
        CreateMartPartnerComponent,
        DetailMartPartnerComponent,
        MartRootComponent,
        MartMerchantsComponent,
        MartDetailMerchantComponent,
        FoodRootComponent,
        FoodRestaurantsComponent,
        FoodCategoriesComponent,
        EditRestaurantComponent,
        MerchantConfirmOnboardingComponent,
        MerchantCompanyConfirmComponent,
        MerchantInformationConfirmComponent,
        MerchantPaymentComponent,
        MerchantPaymentViewComponent,
        MerchantPaymentMethodModalComponent,
        MerchantPaymentMethodSidebarComponent,
        MerchantPaymentDetailsComponent,
        MartDetailMerchantComponent,
        MerchantActivationComponent,
        ApproveDocsMartPartnerComponent,
        MerchantUploadDocumentComponent,
        EditFoodCategoryComponent,
        FoodModifiersComponent,
        EditFoodModifierComponent,
        FoodModifierGroupsComponent,
        EditFoodModifierGroupComponent,
        FoodProductsComponent,
        EditFoodProductComponent,
        MerchantStoreOnboardingComponent,
        MerchantCreateStoreComponent,
        MerchantCreateProductComponent,
        MerchantCreatePaymentComponent,
        MerchantEditProductComponent,
        MerchantEmployeesComponent,
        CreateMerchantEmployeeComponent,
        MerchantStoreDetailComponent,
        MerchantDetailProductComponent,
        MerchantDetailPaymentComponent,
        ReviewPartnerInfoComponent,
        MerchantApprovedRejectProductComponent,
        MerchantRejectProductComponent,
        MerchantEmployeeDetailComponent,
        MerchantSignContractComponent,
        PartnerDashboardSwitchComponent,
        PartnerDashboardRootComponent,
        PartnerDashboardComponent,
        PartnerOrdersRootComponent,
        PartnerOrdersComponent,
        PartnerOrdersFeedbackComponent,
        PartnerMartLocationsRootComponent,
        PartnerEmployeesRootComponent,
        PartnerInventoryRootComponent,
        PartnerFinanceRootComponent,
        PartnerFinanceReportsComponent,
        PartnerFinanceSettlementReportsComponent,
        PartnerMarketingRootComponent,
        PartnerAppconfigRootComponent,
        PartnerInsightsRootComponent,
        PartnerInsightsReportsComponent,
        MostPopularProductsComponent,
        SlowestMovingProductsComponent,
        MostPopularCombinationsComponent,
        MostSearchedProductsComponent,
        PartnerSettingsRootComponent,
        PartnerOrdersFilterComponent,
        MartOrderDetailsComponent,
        MartOrderDetailsInfoTabComponent,
        MartOrderDetailsProductsTabComponent,
        MartOrderDetailsPaymentTabComponent,
        MartOrderDetailsChatTabComponent,
        MartOrderDetailsTimelineTabComponent,
        SuspendPartnerComponent,
        PartnerProfileComponent,
        PartnerProvideAccessComponent,
        PartnerProfileInfoTabComponent,
        PartnerProfileSecurityTabComponent,
        PartnerProfileEmailTabComponent,
        ChatComponent,
        LiveMapAssignRiderComponent,
        PartnerMartLocationsComponent,
        PartnerMartLocationsGroupsComponent,
        PartnerMartLocationsStoreDetailsComponent,
        PartnerMartLocationsInventoryComponent,
        PartnerMartLocationsEmployeeComponent,
        PartnerMartLocationsStoreHoursComponent,
        PartnerMartLocationsHandoffComponent,
        PartnerMartLocationsLegalDocumentsComponent,
        PartnerMartLocationsActiveServicesComponent,
        PartnerMartLocationsCreateGroupComponent,
        PartnerMartLocationsEditGroupComponent,
        PartnerMartLocationsStoreCreateComponent,
        PartnerMartLocationsGroupDetailsComponent,
        PartnerMartLocationsGroupStoresComponent,
        PartnerMartLocationsGroupInventoryComponent,
        PartnerMartLocationsGroupHoursComponent,
        PartnerMartLocationsHeaderComponent,
        PartnerMartLocationsInventoryGridComponent,
        PartnerMartLocationsHoursComponent,
        PartnerMartLocationsDeliveryDetailComponent,
        PartnerMartLocationsSidebarHoursComponent,
        PartnerMartLocationsHoursComponent,
        LegalDocumentsUpdateComponent,
        MerchantProductsComponent,
        PartnerEmployeesComponent,
        PartnerDeleteEmployeeComponent,
        PartnerSuspendEmployeeComponent,
        PartnerEmployeeDetailsComponent,
        PartnerEmployeeResetPasswordComponent,
        PartnerMarketingPromotionsComponent,
        PartnerMarketingAddEditPromotionComponent,
        PartnerMarketingFilterPromotionComponent,
        PartnerEmployeeResetPasswordComponent,
        PartnerSettingsAuthorizedRepresentativeComponent,
        PartnerSettingsBusinessInfoComponent,
        PartnerSettingsPartnershipTermsComponent,
        PartnerSettingsPayoutAccountComponent,
        PartnerSettingsLegalDocumentsComponent,
        PartnerBusinessInfoUpdateComponent,
        PartnerSettingsUpdateLegalDocumentsComponent,
        PartnerSettingsLegalDocumentStatusComponent,
        PartnerPayoutAccountDetailsComponent,
        PartnerFinanceTransactionsComponent,
        PartnerFinanceTransactionDetailComponent,
        PartnerFinanceTransactionFilterComponent,
        HomeTransactionDetailsComponent,
        PartnerAppConfigCategoriesComponent,
        PartnerAppConfigRecommendedProductsComponent,
        PartnerAppConfigStoreBrandingComponent,
        UploadStoreImageComponent,
        LibraryStoreImagesComponent,
        DisciplinaryDetailComponent,
        DisciplinaryInvestigationComponent,
        AddHearingOrReasonComponent,
        SupportRootComponent,
        SupportDriversComponent,
        SupportCustomersComponent,
        OpsTowerRootComponent,
        ComplaintsRootComponent,
        FinancePayoutComponent,
        CampaignUsersRootComponent,
        CampaignUsersTransactionsComponent,
        CampaignUsersUsersComponent,
        FinancePayoutCebuanaComponent,
        FinancePayoutOnlineTransferComponent,
        FinancePayoutUploadComponent,
        FinancePayoutDetailsComponent,
        FinancePayoutSettingsComponent,
        FinanceXenditComponent,
        FinanceCommerceComponent,
        HomeTransactionsFilterComponent,
        OpsTowerRootComponent,
        OpsTowerTODAsComponent,
        FinanceDashboardComponent,
        BackOfficeRootComponent,
        MarketingRootComponent,
        PromotionMaterialsComponent,
        DiscountsReportComponent,
        CustomerQuestComponent,
        IncentiveQuestComponent,
        IncentiveEditComponent,
        PromoBudgetComponent,
        PromoSponsorComponent,
        DriversDraftComponent,
        CustomersSuspendAndBlacklistComponent,
        AccountingDashboardComponent,
        RegistrationV2Component,
        DriversCompaignComponent,
        DriversCompaignXpress50Component,
        BookingDetailComponent,
        BookingReceiptComponent,
        DriverCampaignXpress50RewardComponent,
        OperatorsComponent,
        ExportOperatorsComponent,
        ReportDailyStatisticsComponent,
        PartnerRootComponent,
        PartnerInventoryAllProductsComponent,
        ReportDriverPerformanceComponent,
        ReportTaxiPerformanceComponent,
        ProfileDetailComponent,
        ReportQuestsComponent,
        CompanyDetailsComponent,
        GetChatMessageTypePipe,
        GetChatMessageTitlePipe,
        GetCurrentChatTypePipe,
        MessageDialogComponent,
        MerchantCreateEmployeeComponent,
        MerchantEmployeesSelectionComponent,
        CreateMerchantMultipleEmployeeComponent,
        AddProductDialogComponent,
        AddProductSingleDialogComponent,
        AddProductMultipleDialogComponent,
        ProductDetailFormComponent,
        ProductAvailabilityComponent,
        ProductPricingFormComponent,
        ProductUomFormComponent,
        CurrenyDecimalDirective,
        GetMerchantStatusBackgroundColorPipe,
        PartnerMartLocationsDetailsComponent,
        RolePermissionsComponent,
        GetMerchantStatusBackgroundColorPipe,
        StoreHoursDetailsComponent,
        TaxiVehiclesComponent,
        ConnexBookingsComponent,
        ConnexWalkInBookingDrawerComponent,
        ConnexRouteConfigurationComponent,
        ConnexRouteEditDrawerComponent,
        ConnexAssigningDriversTabComponent,
        ConnexManageDriversDrawerComponent,
		CreateTaxiVehicleComponent,
		TaxiVehicleDetailComponent,
        ProductTableViewComponent,
        ProductGridViewComponent,
        ProductFilterComponent,
        MerchantProductsSidebarComponent,
        ProductFilterComponent,
        MerchantProductsComponent,
        ViewProductDialogComponent,
        EditProductDialogComponent,
        PricingTabComponent,
        UomTabComponent,
        AvailabilityTabComponent,
        ProductDetailViewComponent,
        ProductPricingViewComponent,
        ProductUomViewComponent,
        ProductAvailabilityViewComponent,
        StoreInventoryComponent,
        IsMerchantPipe,
		RefferalReportComponent,
		CurrencyOrEmptyPipe,
        TourBookingsComponent,
        ExperienceListingsComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        FullCalendarModule,
        ImageCropperModule,
        LottieModule.forRoot({ player: () => (player) }),
        HttpClientModule,
        PdfViewerModule,
        ClipboardModule,
        FormsModule,
        NgIf,
        NgForOf,
        NgIf,
        NgSwitchCase,
        AppMaterialModule,
        CreateStoreContainerComponent,
        XpassBookingDetailComponent,
        ReassignDriverComponent,
        XpassComponent,
        AppPrimengModule,
        SharedModule,
        CommsModule,
        OperatorAuthModule,
        OperatorFeaturesSharedModule,
        OperatorVehiclesSharedModule,
        DriversSharedModule,
        CardModule,
        DisciplinarySharedModule,
        GphToolsComponent,
        DndDirective
    ],
    providers: [
        ...appConfig.providers,
		{
			provide: 'JSNLOG',
			useValue: JL
		},
        {
            provide: APP_INITIALIZER,
            useFactory: AuthInitializerFactory.createInitializer,
            deps: [AuthInitializerService],
            multi: true
        },
        MessageService,
        AuthInitializerService,
        {
            provide: ErrorHandler,
            useClass: ErrorProvider,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpProvider,
            multi: true,
        },
        DialogService,
        ApiHttp,
        MenuService,
        ConfigService,
        DeliveryOrderService,
        SharedDeliveryOrderService,
        PaymentProcessingService,
        ArchivingImagesService,
        UserTableSettingsService,
        PayoutTransactionService,
        CebuanaPayoutTransactionService,
        CampaignUsersService,
        SubscriptionService,
        SplashScreenStateService,
        AppDataService,
        AdminXpressConnexService,
        RiderService,
        XpressUserService,
        UserManagementService,
        BoatInquiryService,
        PromosService,
        PromotionMaterialsService,
        PromoSponsorService,
        PromoBudgetService,
        GeoZoneService,
        XpressCenterService,
        RiderScheduleTrainingCenterService,
        MerchantService,
        TourOperatorService,
        NationalityService,
        FoodService,
        MerchantUserService,
        StoreService,
        ProductService,
        ZohoSignService,
        DashboardService,
        PartnerDashboardService,
        PartnerOrderService,
        PartnerProfileService,
        PartnerFinanceService,
        LokalOrderService,
        ChatService,
        QuestService,
        IncentiveQuestService,
        SignalrService,
        GoogleFleetService,
        GooglePlacesService,
        RegionMapEditorService,
        ReportXpressService,
        XpressPaymentTransactionService,
        XpressDisciplinaryService,
        XpressCodeConductService,
        BroadcastMessageService,
        TODAService,
        OperatorService,
        MLService,
        AuthService,
        VehicleBrandService,
        OperatorDashboardService,
        WeblogService,
        UserFeedbackService
    ],
    bootstrap: [AppComponent],
    exports: []
})
export class AppModule { }

